module.exports = __webpack_public_path__ + "img/jindi.968a280b.png";